import { Page, PageTitle } from "@/components/page"
import { CRUDLoader } from "@/components/page/crudloader"
import { CRUDToolbar } from "@/components/page/crudtoolbar"
import { useDatabaseItem, useDatabaseData } from "@/components/page/hooks"
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Textarea } from "@/components/ui/textarea"
import { zodResolver } from "@hookform/resolvers/zod"
import { Folder } from "lucide-react"
import { useForm } from "react-hook-form"
import { z } from "zod"

export const projects_crud = {
  title: "Project",
  route: "/settings/projects/:id",
  component,
  group: "settings",
  resource: "projects",
  icon: Folder,
  action: "read",
} satisfies PageConfig

const FormSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
  team: z.string().min(1, "Team is required"),
})

type FormData = z.infer<typeof FormSchema>

export function component() {

  const { data, loading, submit, toastSuccess, navigate, } = useDatabaseItem("projects")
  const { data: teams, loading: teamsLoading } = useDatabaseData("teams")

  const form = useForm<FormData>({
    resolver: zodResolver(FormSchema),
    defaultValues: data,
    values: data,
  })

  async function onSubmit(data: FormData) {
    console.log("Submit: ", data)
    await submit(data)
    toastSuccess()
    navigate("/settings/projects")
  }

  if (loading || teamsLoading) return <CRUDLoader />

  return <Page>
    <div className="pb-8">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <PageTitle>
            <CRUDToolbar table="projects" onSuccess={"/settings/projects"} />
          </PageTitle>
          <div className="rgrid">
            <div className="row">
              <div className="rc-6">
                <FormField control={form.control} name="name" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Name</FormLabel>
                    <FormControl><Input {...field} /></FormControl>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
              <div className="rc-6">
                <FormField control={form.control} name="team" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Team</FormLabel>
                    <Select value={field.value} onValueChange={field.onChange} defaultValue={field.value}>
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="Select a team" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        {teams?.map((team) => (
                          <SelectItem key={team.id} value={team.id}>
                            {team.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
            </div>
            <div className="row">
              <div className="rc-12">
                <FormField control={form.control} name="description" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Description</FormLabel>
                    <FormControl><Textarea {...field} /></FormControl>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
            </div>
          </div>
        </form>
      </Form>
    </div>
  </Page>

}
